<template>
  <span class="staff-avatar" :class="{ 'is-small': small }" :style="{ backgroundColor: color }" :title="fullName">
    {{ initials }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { hashCode } from "@/utils/common"
import { nameInitials } from "@/modules/patient-conversations/utils/patient-conversation-format"

// Tailwind theme colors (purple, primary-500, primary-400, yellow-500, red-200, neutral-600)
const AVATAR_COLORS = ["#8974FF", "#467886", "#56B7A9", "#D39D15", "#E16C68", "#5C6C70"]

const props = defineProps<{
  fullName: string
  small?: boolean
}>()

const initials = computed<string>(() => nameInitials(props.fullName))
const color = computed<string>(() => AVATAR_COLORS[Math.abs(hashCode(props.fullName)) % AVATAR_COLORS.length])
</script>

<style scoped lang="sass">
.staff-avatar
  display: inline-flex
  align-items: center
  justify-content: center
  flex: none
  width: 24px
  height: 24px
  border-radius: 9999px
  color: white
  font-size: 10px
  font-weight: 700
  letter-spacing: 0.02em
  line-height: 1

  &.is-small
    width: 20px
    height: 20px
    font-size: 9px
</style>
